import { useToast } from "@/app/components/ui/use-toast"
import {
  ITabGame,
  ITopupGameDetail,
  ITopupPackage,
  ITopupSelectedData,
  ITopupServer
} from "@/app/interfaces/ITopup"
import TopupService from "@/app/services/services/TopupService"
import { useTranslation } from "next-i18next"
import { useRouter } from "next/router"
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react"
import { initSelectedData } from ".."
import { Input } from "@/app/components/ui/input"
import { Button } from "@/app/components/ui/button"
import { LoadingBtnComponent } from "@/app/components/loading-btn"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/app/components/ui/select"
import { TOPUP_STEP } from "../topup.constant"
import useGAEventsTracker from "@/app/hooks/useGAEventsTracker"
import { convertObjectToArray } from "@/app/utils"
import { AppContext } from "@/app/context"
import { IconClose } from "@/app/components/icon-tsx/IconClose"
import { LoadingTopup } from "./LoadingTopup"
import { ChevronDown, Search } from "lucide-react"

interface TopupUserInfoProps {
  gameDetail: ITopupGameDetail & ITopupServer
  selectedData: ITopupSelectedData
  setSelectedData: Dispatch<SetStateAction<ITopupSelectedData>>
  setSelectedTab: Dispatch<SetStateAction<ITabGame | undefined>>
  setSourcePackageAndTab: Dispatch<SetStateAction<ITopupPackage | undefined>>
  setStep: Dispatch<SetStateAction<number>>
  handleSetExtendData: (value: {
    alreadyGoldGift: number
    totalLimit: number
  }) => void
  setListPackageType: (value: "image" | "text") => void
}

export const ConfirmIdStep: React.FC<TopupUserInfoProps> = ({
  gameDetail,
  selectedData,
  setSelectedData,
  setSourcePackageAndTab,
  setSelectedTab,
  setStep,
  handleSetExtendData,
  setListPackageType
}) => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const router = useRouter()
  const { userInfo } = useContext(AppContext)
  const [userID, setUserID] = useState<string>("")
  const [listServer, setListServer] = useState<any>([])
  const [listPlatform, setListPlatform] = useState<any>([])
  const [role, setRole] = useState<{ role_id: string; role_name: string }[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [errorInputValue, setErrorInputValue] = useState<string>("")
  const GAEventsTracker = useGAEventsTracker("Store_TopupGame")
  const OptionRole = role.map(
    (item: { role_id: string; role_name: string }) => ({
      title: item?.role_name,
      value: item?.role_id
    })
  )

  const OptionCountry = gameDetail?.country_list
    ? Object.entries(gameDetail?.country_list).map(([key, value]) => ({
        value: key,
        title: value
      }))
    : []

  useEffect(() => {
    if (router.query.slug_name) {
      setListServer([])
      setListPlatform([])
      setRole([])
      setSelectedData(initSelectedData)
    }
  }, [router, setSelectedData])
  const disablebtn = () => {
    if (!userID) {
      return true
    } else {
      if (
        selectedData.selectRole.role_id &&
        selectedData.selectServer.server_id
      ) {
        return false
      }
      if (!listServer.length) {
        return false
      }
      return true
    }
  }

  useEffect(() => {
    if (
      !!selectedData?.selectServer?.server_id &&
      !!selectedData?.selectUser?.user_id &&
      router?.query?.slug_name !== "napla"
    ) {
      if (listPlatform?.length > 0) {
        if (selectedData?.selectPlatform?.platform_id) {
          getRoleByServerAndUserId(
            String(router?.query?.slug_name),
            selectedData?.selectServer?.server_id,
            selectedData?.selectUser?.user_id,
            selectedData?.selectPlatform?.platform_id
          )
        }
      } else {
        getRoleByServerAndUserId(
          String(router?.query?.slug_name),
          selectedData?.selectServer?.server_id,
          selectedData?.selectUser?.user_id
        )
      }
    }
  }, [
    selectedData?.selectServer?.server_id,
    selectedData?.selectUser?.user_id,
    selectedData?.selectPlatform?.platform_id,
    listPlatform,
    router
  ])

  const onChangeText = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (
      !!selectedData?.selectUser?.user_id &&
      selectedData?.selectUser?.user_id !== e?.target?.value
    ) {
      setListServer([])
      setListPlatform([])
      setRole([])
      setSelectedData(initSelectedData)
      setUserID(e?.target?.value)
    } else {
      setUserID(e?.target?.value)
      if (e?.target?.value === "") {
        setSelectedData({
          ...selectedData,
          selectUser: {
            user_id: "",
            username: ""
          }
        })
        setRole([])
        setListServer([])
        setListPlatform([])
      }
    }
    setErrorInputValue("")
  }

  const submitGetRole = (e: any) => {
    if (!userID?.trim()) {
      setErrorInputValue(
        t("topup.error_select_userid", {
          value: gameDetail?.is_copub === "yes" ? "User Id" : "Gamota Username"
        })
      )
    }
    if (e.keyCode == 13 && !!userID.trim()) {
      getServerUserAndPlatformByUserId({
        slug_name: String(router?.query?.slug_name),
        user_id: userID?.trim()
      })
    }
  }

  // chọn xong user_id thì get về server_id và platform
  const getServerUserAndPlatformByUserId = async (params: {
    slug_name: string
    user_id: string
  }) => {
    try {
      setLoading(true)
      const res = await TopupService.getServerUserAndPlatformByUserId(params)
      if (res?.data?.errorCode === 0) {
        GAEventsTracker("Store_Topup_IDinput", "Search User info")
        if (res?.data?.data?.user?.user_id) {
          const data = res?.data?.data
          setSelectedData({
            ...selectedData,
            selectUser: data?.user
          })
          setListServer(() =>
            Object.entries(data?.servers).map(([server_id, server_name]) => ({
              title: server_name,
              value: server_id
            }))
          )

          if (data?.platform) {
            setListPlatform(() =>
              Object.entries(data?.platform ?? {}).map(
                ([platform_id, platform_name]) => ({
                  title: platform_name,
                  value: platform_id
                })
              )
            )
          }
        } else {
          setErrorInputValue(t("profile.no_data"))
        }
      } else {
        toast({
          title: res?.data?.message || t("message.DEFAULT_ERROR"),
          variant: "error"
        })
      }
      setLoading(false)
    } catch (err: any) {
      toast({
        title:
          err?.data?.message ||
          err?.response?.data?.message ||
          t("message.DEFAULT_ERROR"),
        variant: "error"
      })
    } finally {
      setLoading(false)
    }
  }

  // khi chọn user_id và server_id thì get về role_id
  const getRoleByServerAndUserId = async (
    slug_name: string,
    server_id: string,
    user_id: string,
    platform?: string
  ) => {
    setLoading(true)
    try {
      const param = platform
        ? {
            slug_name,
            server_id,
            user_id,
            platform
          }
        : {
            slug_name,
            server_id,
            user_id
          }
      const res = await TopupService.getRoleByServerAndUserId(param)
      if (res?.data?.errorCode === 0) {
        setRole(res?.data?.data)
        setSelectedData({
          ...selectedData,
          selectRole: res?.data?.data[0]
        })
      } else toast({ title: res?.data?.message, variant: "error" })
      setLoading(false)
    } catch (err: any) {
      setErrorInputValue(
        err?.data?.message ??
          err?.response?.data?.message ??
          t("message.DEFAULT_ERROR")
      )
    } finally {
      setLoading(false)
    }
  }

  const SelectInput = ({
    listItem,
    title,
    placeholder,
    onSelect,
    value,
    classname,
    enableSearch = false
  }: {
    listItem: any
    title: string
    placeholder: string
    onSelect?: (param: any) => void
    value: string
    classname?: string
    enableSearch?: boolean
  }) => {
    const [searchTerm, setSearchTerm] = useState<string>("")
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const searchInputRef = useRef<HTMLInputElement>(null)
    const dropdownRef = useRef<HTMLDivElement>(null)

    const filteredItems = useMemo(() => {
      if (!enableSearch || !searchTerm) return listItem || []
      return (listItem || []).filter((item: any) =>
        item.title?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    }, [listItem, searchTerm, enableSearch])

    const selectedItem = listItem?.find((item: any) => item.value === value)

    useEffect(() => {
      if (!isOpen) {
        setSearchTerm("")
      }
    }, [isOpen])

    useEffect(() => {
      if (isOpen && enableSearch && searchInputRef.current) {
        setTimeout(() => {
          searchInputRef.current?.focus()
        }, 100)
      }
    }, [isOpen, enableSearch])
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target as Node)
        ) {
          setIsOpen(false)
        }
      }

      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside)
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside)
      }
    }, [isOpen])

    const handleItemSelect = (item: any) => {
      onSelect?.(item.value)
      setIsOpen(false)
      setSearchTerm("")
    }

    const handleInputKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === "Escape") {
        setIsOpen(false)
      } else if (e.key === "ArrowDown") {
        e.preventDefault()
        const firstItem = dropdownRef.current?.querySelector(
          "[data-item]"
        ) as HTMLElement
        firstItem?.focus()
      }
    }

    const handleItemKeyDown = (e: React.KeyboardEvent, item: any) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault()
        handleItemSelect(item)
      }
    }
    if (!enableSearch) {
      return (
        <div className={`mt-[24px] ${classname}`}>
          <h2 className="text-[16px] pb-[8px] pl-[24px]">{title}:</h2>
          <Select onValueChange={onSelect} value={value}>
            <SelectTrigger className="h-[52px] px-[24px] py-[13px] rounded-[16px] border border-black/10 dark:bg-white/10 text-[16px]">
              <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent>
              {listItem?.map((item: any, index: number) => {
                return (
                  <SelectItem
                    value={item?.value}
                    key={item?.value}
                    className="p-3 hover:!bg-bg-disable hover:!text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]"
                  >
                    {item?.title}
                  </SelectItem>
                )
              })}
            </SelectContent>
          </Select>
        </div>
      )
    }

    return (
      <div className={`mt-[24px] ${classname}`} ref={dropdownRef}>
        <h2 className="text-[16px] pb-[8px] pl-[24px]">{title}:</h2>

        <div className="relative">
          <div
            className="h-[52px] px-[24px] py-[13px] rounded-[16px] border border-black/10 dark:bg-white/10 text-[16px] bg-white dark:bg-gray-800 cursor-text flex items-center"
            onClick={() => setIsOpen(true)}
          >
            <Search className="h-4 w-4 mr-3 flex-shrink-0" />
            <input
              ref={searchInputRef}
              type="text"
              placeholder={selectedItem ? selectedItem.title : placeholder}
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value)
                if (!isOpen) setIsOpen(true)
              }}
              onKeyDown={handleInputKeyDown}
              onFocus={() => setIsOpen(true)}
              className="flex-1 outline-none text-[16px] text-black placeholder:text-black"
            />
            <ChevronDown
              className={`h-4 w-4 transition-transform ${
                isOpen ? "rotate-180" : ""
              }`}
            />
          </div>
          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-gray-800 border border-black/10 rounded-[16px] shadow-lg z-50 max-h-80 overflow-hidden">
              <div className="max-h-48 overflow-y-auto">
                {(searchTerm ? filteredItems : listItem || []).length > 0 ? (
                  (searchTerm ? filteredItems : listItem || []).map(
                    (item: any, index: number) => (
                      <div
                        key={item?.value || index}
                        data-item
                        tabIndex={0}
                        className="p-3 hover:bg-bg-disable hover:text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:bg-[#F1F1FC]/[.1] dark:focus:bg-[#F1F1FC]/[.1] cursor-pointer outline-none"
                        onClick={() => handleItemSelect(item)}
                        onKeyDown={(e) => handleItemKeyDown(e, item)}
                      >
                        {item?.title}
                      </div>
                    )
                  )
                ) : (
                  <div className="p-3 text-center text-sm">
                    {searchTerm ? "Không tìm thấy kết quả" : "Không có dữ liệu"}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  //lọc ra các tab game không có package nào Active
  const filterTabGames = (packageAndTab: ITopupPackage) => {
    if (packageAndTab?.tabGame && packageAndTab?.tabGame?.length > 0) {
      const _filterList = packageAndTab?.tabGame?.filter((tab) => {
        const filterObject = Object.fromEntries(
          Object.entries(packageAndTab?.packages).filter(([key]) =>
            tab.package.includes(key)
          )
        )

        const _package = convertObjectToArray(filterObject)

        if (_package?.length) {
          return true
        }
        return false
      })

      return _filterList
    }
    return []
  }

  // khi đủ role_id và server_id thì get list package và tablist
  const getSourcePackageAndTab = async (
    slug_name: string,
    user_id?: string,
    server_id?: string,
    role_id?: string,
    platform?: string
  ) => {
    setLoading(true)
    try {
      const res = await TopupService.getSourcePackageAndTab({
        slug_name,
        user_id: user_id ? user_id : selectedData?.selectUser?.user_id,
        server_id: server_id
          ? server_id
          : selectedData?.selectServer?.server_id,
        role_id: role_id ? role_id : selectedData?.selectRole?.role_id,
        platform: platform
          ? platform
          : selectedData?.selectPlatform?.platform_id
      })
      if (res?.data?.errorCode === 0) {
        const data = res?.data?.data
        if (!!data?.extendData) {
          handleSetExtendData(data?.extendData)
        }
        const listTabGames = filterTabGames(data)
        setSourcePackageAndTab({
          ...data,
          tabGame: listTabGames
        })
        if (!!data?.tabGame) {
          setSelectedTab(listTabGames[0])
        }
        if (data?.list_package_type) {
          setListPackageType(data?.list_package_type)
        }
        setStep(TOPUP_STEP.PACKAGE_METHOD)
      } else {
        toast({ title: res?.data?.message, variant: "error" })
      }
    } catch (err: any) {
      toast({
        title: err?.data?.message ?? err?.response?.data?.message,
        variant: "error"
      })
    } finally {
      setLoading(false)
    }
  }

  // khi đủ role_id và server_id thì get list package và tablist
  const getSourcePackageAndTabInOpenGlobal = async (slug_name: string) => {
    setLoading(true)
    try {
      const res = await TopupService.getSourcePackageAndTabInOpenGlobal({
        slug_name,
        country_code: selectedData?.country_code || ""
      })

      if (res?.data?.errorCode === 0) {
        const data = res?.data?.data
        if (!!data?.extendData) {
          handleSetExtendData(data?.extendData)
        }
        const listTabGames = filterTabGames(data)
        setSourcePackageAndTab({
          ...data,
          tabGame: listTabGames
        })
        if (!!data?.tabGame) {
          setSelectedTab(listTabGames[0])
        }
        if (data?.list_package_type) {
          setListPackageType(data?.list_package_type)
        }
        setStep(TOPUP_STEP.PACKAGE_METHOD)
      } else {
        toast({ title: res?.data?.message, variant: "error" })
      }
    } catch (err: any) {
      toast({
        title: err?.data?.message ?? err?.response?.data?.message,
        variant: "error"
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!!gameDetail?.last_transaction?.username) {
      setUserID(gameDetail?.last_transaction?.username || "")
    } else if (gameDetail?.is_copub === "no") {
      setUserID(userInfo?.username)
    } else {
      setUserID("")
    }
  }, [
    gameDetail?.is_copub,
    gameDetail?.last_transaction?.username,
    userInfo?.username
  ])

  useEffect(() => {
    if (
      selectedData.selectUser?.user_id &&
      selectedData.selectServer?.server_id &&
      router?.query?.slug_name === "napla"
    ) {
      getSourcePackageAndTab(
        "napla",
        userInfo.userid,
        userInfo.userid,
        userInfo.userid
      )
    }
  }, [router, userInfo, selectedData, getSourcePackageAndTab])

  return (
    <div className="md:mt-[64px] md:max-w-[450px] mx-auto flex flex-col h-full w-full flex-1 pb-[48px]">
      {/* enter username */}
      {router.query?.slug_name === "napla" ? (
        <div>
          <LoadingTopup />
        </div>
      ) : (
        <>
          <div className="relative cursor-pointer">
            <div className="flex items-center justify-between">
              <p className="text-[16px] pb-[8px] md:pl-[24px]">
                {t("topup.input_id", {
                  field: gameDetail?.is_copub === "yes" ? "ID" : "Username"
                })}
                :
              </p>
              <div className="relative inline-block group">
                <p className="text-[10px] flex items-center gap-1 text-main-01 font-semibold">
                  {gameDetail?.is_copub === "yes" && (
                    <>
                      Hướng dẫn lấy UserID
                      <span
                        className="mb-[5px]"
                        dangerouslySetInnerHTML={{
                          __html: `
                              <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_26623_141953)">
                                  <path d="M5.70195 4.7L6.0173 4.90292L5.70195 4.7ZM3.79232 4.24967C3.79232 4.45678 3.96021 4.62467 4.16732 4.62467C4.37442 4.62467 4.54232 4.45678 4.54232 4.24967H3.79232ZM4.62565 6.12467C4.62565 6.33178 4.79354 6.49967 5.00065 6.49967C5.20776 6.49967 5.37565 6.33178 5.37565 6.12467H4.62565ZM5.37565 7.16634C5.37565 6.95923 5.20776 6.79134 5.00065 6.79134C4.79354 6.79134 4.62565 6.95923 4.62565 7.16634H5.37565ZM4.62565 7.58301C4.62565 7.79011 4.79354 7.95801 5.00065 7.95801C5.20776 7.95801 5.37565 7.79011 5.37565 7.58301H4.62565ZM9.16732 5.49967H8.79232C8.79232 7.59375 7.09473 9.29134 5.00065 9.29134V9.66634V10.0413C7.50894 10.0413 9.54232 8.00797 9.54232 5.49967H9.16732ZM5.00065 9.66634V9.29134C2.90657 9.29134 1.20898 7.59375 1.20898 5.49967H0.833984H0.458984C0.458984 8.00797 2.49236 10.0413 5.00065 10.0413V9.66634ZM0.833984 5.49967H1.20898C1.20898 3.40559 2.90657 1.70801 5.00065 1.70801V1.33301V0.958008C2.49236 0.958008 0.458984 2.99138 0.458984 5.49967H0.833984ZM5.00065 1.33301V1.70801C7.09473 1.70801 8.79232 3.40559 8.79232 5.49967H9.16732H9.54232C9.54232 2.99138 7.50894 0.958008 5.00065 0.958008V1.33301ZM5.83398 4.24967H5.45898C5.45898 4.34148 5.43238 4.42592 5.38659 4.49708L5.70195 4.7L6.0173 4.90292C6.13863 4.71437 6.20898 4.48966 6.20898 4.24967H5.83398ZM4.16732 4.24967H4.54232C4.54232 3.99654 4.74752 3.79134 5.00065 3.79134V3.41634V3.04134C4.33331 3.04134 3.79232 3.58233 3.79232 4.24967H4.16732ZM5.00065 3.41634V3.79134C5.25378 3.79134 5.45898 3.99654 5.45898 4.24967H5.83398H6.20898C6.20898 3.58233 5.668 3.04134 5.00065 3.04134V3.41634ZM5.00065 5.91634H4.62565V6.12467H5.00065H5.37565V5.91634H5.00065ZM5.70195 4.7L5.38659 4.49708C5.33608 4.57558 5.27225 4.6577 5.19514 4.75353C5.12195 4.84449 5.03372 4.95146 4.95468 5.06009C4.79924 5.27372 4.62565 5.56273 4.62565 5.91634H5.00065H5.37565C5.37565 5.80971 5.42818 5.68408 5.56114 5.50135C5.62629 5.41181 5.69782 5.32518 5.77947 5.2237C5.8572 5.1271 5.94329 5.01794 6.0173 4.90292L5.70195 4.7ZM5.00065 7.16634H4.62565V7.58301H5.00065H5.37565V7.16634H5.00065Z" fill="#3263E4"/>
                                </g>
                                <defs>
                                  <clipPath id="clip0_26623_141953">
                                    <rect width="10" height="10" fill="white" transform="translate(0 0.5)"/>
                                  </clipPath>
                                </defs>
                              </svg>
                            `
                        }}
                      />
                    </>
                  )}
                </p>
                {gameDetail?.guide_img && (
                  <div className="absolute overflow-visible min-w-fit right-[10px] lg:right-auto lg:left-[40px] bottom-6 z-10 scale-0 group-hover:scale-100 transition-all duration-200 origin-bottom">
                    <div className="w-2 h-2 bg-white shadow-2xl rotate-45 absolute bottom-[-6px] right-[20px] lg:right-auto lg:left-[62px] z-0"></div>
                    <div className="relative p-[2px] bg-white rounded-md border border-input-border-light shadow-lg z-10">
                      <img
                        src={gameDetail?.guide_img}
                        alt="Hướng dẫn UserID"
                        className="rounded-md shadow-lg border min-w-[350px] sm:min-w-[400px] lg:min-w-[500px] xl:min-w-[550px]  "
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="relative">
              <Input
                onBlur={submitGetRole}
                placeholder={t("topup.input_user_id", {
                  field:
                    gameDetail?.is_copub === "yes"
                      ? "User ID"
                      : "Gamota Username"
                })}
                className="h-[52px] px-[24px] py-[13px] rounded-[16px] border border-black/10 text-[16px] dark:bg-white/10"
                onChange={onChangeText}
                onKeyDown={submitGetRole}
                value={userID?.trim()}
              />
              {!!userID && (
                <IconClose
                  className="absolute cursor-pointer top-[35%] w-[16px] h-[16px] right-[16px]"
                  onClick={() => {
                    setUserID("")
                  }}
                />
              )}
            </div>

            {errorInputValue != "Server incorrect" && (
              <p className="text-xs text-main-red Nunito-400 absolute -bottom-4 pl-[6px]">
                {errorInputValue}
              </p>
            )}
          </div>

          {/* Select country if gameDetail?.open_global = 'yes' */}
          {!!listServer?.length && gameDetail?.open_global === "yes" && (
            <>
              <div className="max-w-[343px] w-full mx-auto mt-[24px] border border-dashed border-black/10 dark:border-white/10 h-[1.5px]"></div>
              <SelectInput
                listItem={OptionCountry}
                title={t("store.select_country")}
                placeholder={t("store.select_country")}
                value={selectedData?.country_code || ""}
                onSelect={(value) => {
                  setSelectedData({
                    ...selectedData,
                    country_code: value
                  })
                }}
                enableSearch={true}
              />
            </>
          )}

          {/* Select server */}
          {!!listServer?.length && (
            <>
              <SelectInput
                listItem={listServer}
                title={t("topup.server")}
                enableSearch={true}
                placeholder={t("topup.server")}
                value={selectedData.selectServer.server_id}
                onSelect={(value) => {
                  GAEventsTracker(
                    "Store_Topup_Selectserver",
                    "Search User info"
                  )
                  setSelectedData({
                    ...selectedData,
                    selectServer: {
                      server_id: value,
                      server_name:
                        listServer?.find((item: any) => item?.value === value)
                          ?.title ?? ""
                    }
                  })
                }}
              />
            </>
          )}

          {/* Select platform */}
          {!!listPlatform?.length && (
            <SelectInput
              listItem={listPlatform}
              title={t("topup.platform")}
              placeholder={t("topup.platform")}
              value={selectedData.selectPlatform.platform_id}
              onSelect={(value) => {
                setSelectedData({
                  ...selectedData,
                  selectPlatform: {
                    platform_id: value,
                    platform_name:
                      listPlatform?.find((item: any) => item?.value === value)
                        ?.title ?? ""
                  }
                })
              }}
            />
          )}

          {!!role?.length && (
            <SelectInput
              listItem={OptionRole}
              title={t("topup.name_role")}
              placeholder={t("topup.name_role")}
              classname="mb-[32px] md:mb-[0px]"
              value={selectedData.selectRole.role_id}
              onSelect={(value) => {
                setSelectedData({
                  ...selectedData,
                  selectRole: role?.find((item) => item?.role_id === value) ?? {
                    role_id: "",
                    role_name: ""
                  }
                })
              }}
            />
          )}

          <Button
            variant="main"
            onClick={() => {
              if (!selectedData?.selectUser?.user_id) {
                getServerUserAndPlatformByUserId({
                  slug_name: String(router?.query?.slug_name),
                  user_id: userID?.trim()
                })
              } else if (
                !selectedData?.country_code &&
                gameDetail?.open_global === "yes"
              ) {
                toast({
                  title: t("store.select_country"),
                  variant: "error"
                })
              } else if (
                gameDetail?.open_global === "yes" &&
                selectedData?.country_code !== "VN"
              ) {
                getSourcePackageAndTabInOpenGlobal(gameDetail?.slug_name)
              } else {
                getSourcePackageAndTab(gameDetail?.slug_name)
              }
            }}
            disabled={disablebtn()}
            className="mx-auto mt-auto mb-0 md:mt-[32px] text-[14px] w-full h-[45px] leading-[19px] rounded-[16px]"
          >
            {loading ? <LoadingBtnComponent /> : t("reward.confirm")}
          </Button>
        </>
      )}
    </div>
  )
}
